'use client'

import { motion } from "motion/react";
import useMeasure from "react-use-measure";
import { cn } from "@/lib/utils";

type AutoResizeProps = {
  children: React.ReactNode;
  property?: "height" | "width" | "both";
} & React.HTMLAttributes<HTMLDivElement>


export function AutoResize({ children, property = "both", className, ...props }: AutoResizeProps) {
  const [ref, bounds] = useMeasure();

  return (
    <motion.div animate={{ 
      height: property === "height" ? bounds.height > 0 ? bounds.height : "auto" : "auto", 
      width: property === "width" ? bounds.width > 0 ? bounds.width : "auto" : "auto",
    }}>
      <div ref={ref} className={cn(className)} {...props}>{children}</div>
    </motion.div>
  );
}